import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import { useProfileStore } from '@entities/viewer'
import { useDayjs } from '@shared/lib/format'

import { useDisciplineStore } from '../store'

interface LessonCustomerTimezoneReturn {
  refTimezone: ComputedRef<string>
  refTime: ComputedRef<string>
}

/** The customer's clock next to the tabs, as the legacy Lessons page showed it: lesson times are picked in the admin's
 *  timezone, but agreed with the customer in theirs. */
export const useLessonCustomerTimezone = (): LessonCustomerTimezoneReturn => {
  const dayjs = useDayjs()
  const disciplineStore = useDisciplineStore()
  const profileStore = useProfileStore()

  const refTimezone = computed<string>(() => disciplineStore.getDetails?.customer?.timezone ?? '')

  const refTime = computed<string>(() => {
    const nowUtc = profileStore.options?.current_time_utc
    if (!nowUtc || !refTimezone.value) return ''

    try {
      return dayjs.utc(nowUtc, DateFormat.Default).tz(refTimezone.value).format(DateFormat.KanbanDate)
    } catch {
      return ''
    }
  })

  return {
    refTimezone,
    refTime,
  }
}
